module.exports = __webpack_public_path__ + "img/sheis.d9aa96b4.png";